import component from "./en-US/component";
import globalHeader from "./en-US/globalHeader";
import menu from "./en-US/menu";
import pwa from "./en-US/pwa";
import settingDrawer from "./en-US/settingDrawer";
import settings from "./en-US/settings";
import login from "./en-US/login";
import xero from "./en-US/xero";
import apikey from "./en-US/apikey";
import organisation from "./en-US/organisation";
import settlement from "./en-US/settlement";
import mallUpload from "./en-US/mallUpload";
import menuManagement from "./en-US/menuManagement";
import logs from "./en-US/logs";
import deliveryPlatform from "./en-US/deliveryPlatform";

export default {
    "navBar.lang": "Languages",
    "common.view": "View",
    "common.create": "Create",
    "common.next": "Next",
    "common.add": "Add",
    "common.edit": "Edit",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.cancel": "Cancel",
    "common.currency-symbol": "$",
    "common.confirm": "Confirm",
    "common.ok": "OK",
    "common.close": "Close",
    "common.yes": "Yes",
    "common.no": "No",
    "common.filter": "Filter",
    "common.search": "Search",
    "common.action": "Action",
    "crudtable.showing-1": "Showing",
    "crudtable.showing-2": "of",
    "crudtable.showing-3": "items",
    "common.search-brand-outlet": "Select a brand or outlet",
    "common.all-brands": "All Brands",
    "common.all-outlets": "All Outlets",
    "common.all-terminals": "All Terminals",
    "common.all-payment-type": "All Payment Types",
    "common.on": "On",
    "common.off": "Off",
    "common.date": "Date",
    "common.searchBrandOutletTerminal": "Brand Name, Outlet Name, or Terminal",
    "common.selectBrandOutletTerminal": "Select a Brand, Outlet, or Terminal",
    "common.back": "Back",
    ...globalHeader,
    ...menu,
    ...settingDrawer,
    ...settings,
    ...pwa,
    ...component,
    ...login,
    ...xero,
    ...apikey,
    ...organisation,
    ...settlement,
    ...mallUpload,
    ...menuManagement,
    ...logs,
    ...deliveryPlatform
};
